import { Component, OnInit, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserService } from 'app/rest/user.service';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';

import { SinisterService } from 'app/modules/vehicle-inventory/services/table-management/sinister.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { DriverService } from 'app/modules/vehicle-inventory/services/driver.service';
import {LeaderService} from 'app/rest/leader.service';
import { SinisterTypeService } from 'app/modules/vehicle-inventory/services/table-management/sinisterType.service';
import {WorkshopService} from 'app/modules/vehicle-inventory/services/table-management/workshop.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { WorkshopFormComponent } from '../../sinister/workshop/workshop-form/workshop-form.component';
import { ObservationsFormComponent } from '../../observations/observations-form/observations-form.component';
import { ObservationsListComponent } from '../../observations/observations-list/observations-list.component';
@Component({
  selector: 'app-sinister-form',
  templateUrl: './sinister-form.component.html',
  styleUrls: ['./sinister-form.component.css'],
  providers:[SinisterService, InvVehicleService, DriverService, LeaderService, SinisterTypeService, WorkshopService],
  standalone: false,
})
export class SinisterFormComponent extends EntityFormComponent<Rest.InvSinister> implements OnInit {

 @Input() vehicle?: Rest.Vehicle = null;
	@Input() startDate?: Date = null;
	@Input() endDate?: Date = null;

	noticeChannels: SelectItem[];
	channelsList: Rest.NoticeChannel[];
	title: string;

	active: boolean;
	ids: number[] = [];
	idsObservations: number[] = [];

	/*Permissions */
	disableSave: boolean;
	disabeChangeStatus: boolean;

	payDate: Date;
	defaultDate: Date = new Date();
	now: string;

	editVehicle: boolean;
	backupVehicle: Rest.Vehicle;
	vehiclePlaceholder: string;

	observationType: Rest.InvObservationsType = "SINISTER";

	vehicleRequestContext: any;
  driverRequestContext: any;
  leaderRequestContext: any;
  sinisterTypeRequestContext: any;
  workshopRequestContext: any;

	vehicleList: Rest.Vehicle[] = [];

	file: File;

	errorMessages: string[] = [];
	saving: boolean = false;
  driverList: Rest.InvDriver[] = [];

  fleetManagerList: Rest.User[] = [];
  sinisterTypeList: Rest.InvSinisterType[] = [];
  workshopList: Rest.InvWorkshop[] = [];

  modeCulpability: any = [
    {label: this.translateService.instant('deviceParameters.dropdownLabels.aSEGURADO'),value:"INSURED"},
    {label: this.translateService.instant('deviceParameters.dropdownLabels.cONTRARIO'),value:"COUNTER"},          
  ];

    sinisterDate: Date;
  	expertDay: Date;
	workshopStartDate: Date;
	workshopEndDate: Date;
	vehiclePickupDate: Date;
	vehicleReturnDate: Date;
	endReparationDate: Date;
	formManipulation: boolean;

	@ViewChild(WorkshopFormComponent, { static: true })workshopForm: WorkshopFormComponent;
	activeTab: string = 'workshop';

// Método para cambiar de pestaña manualmente
selectTab(tabId: string) {
    this.activeTab = tabId;
}

	constructor(
		private SinisterService: SinisterService,
		notificationsService: NotificationsService,
		protected i18n: I18nService,
		private authenticationService: AuthenticationService,
		public translateService: TranslateService,
		public userService: UserService,
		public invVehicleService: InvVehicleService,
        public driverService: DriverService,
        public leaderService: LeaderService,
        public sinisterTypeService: SinisterTypeService,
        public workshopService: WorkshopService,
	    private userTime: UserTimePipe

	) {
		super(SinisterService, notificationsService, i18n, authenticationService);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setPermissions();
	}

	/**
	 * Loads and evaluates all the necessary data before showing the form.
	 *
	 * @memberof TaxFormComponent
	 */
	beforeShow() {
		this.errorMessages = [];
		this.errorMessages.length = 0;

    var that = this;
		this.ids = [];
		this.idsObservations = [];
		if (this.entity.documents && this.entity.documents.length > 0) {
			this.entity.documents.forEach((x) => this.ids.push(x.id));
		} else {
			this.ids = [-1];
		}

		if(this.entity.observations && this.entity.observations.length > 0){
			this.entity.observations.forEach((x) => this.idsObservations.push(x.id));
		}else{
			this.idsObservations = [-1];
		}

		if (this.vehicle) {
			this.entity.vehicle = this.vehicle;
		}

		this.editVehicle = true;

		    this.driverRequestContext = {
			sortBy: 'employee.code',
			sortAsc: true,
			pageSize: 10,
			loadPermissions: false,
			filters: {},
		} as Rest.ListPaginationRequest;


		/*Permissions */
		if (this.isNew) {
			this.disableSave = false;
			if (this.vehicle !== null) {
				this.entity.vehicle = this.vehicle;
			}
			this.title = !this.vehicle
				? this.translateService.instant('tableManagement.sinister.createSinister')
				: this.vehicle.name +
				  ' ' +
				  this.vehicle.model?.brand?.name +
				  ' - ' +
				  this.vehicle.model?.name +
				  ' - ' +
				  this.vehicle.version?.name + 
				  (this.vehicle.version ? ' (' + this.translateService.instant('tableManagement.fuelType.'+this.vehicle.version?.fuelType) + ')' : '');
			if (this.entity.vehicle) {
				this.assignDriverFromVehicle();
			}
		} else {
			this.title = !this.vehicle
				? this.translateService.instant('tableManagement.sinister.updateSinister')
				: this.vehicle.name +
				  ' ' +
				  this.vehicle.model?.brand?.name +
				  ' - ' +
				  this.vehicle.model?.name +
				  ' - ' +
				  this.vehicle.version?.name + 
				  (this.vehicle.version ? ' (' + this.translateService.instant('tableManagement.fuelType.'+this.vehicle.version?.fuelType) + ')' : '');
			if (this.entity['_$update'] === true) {
				this.disableSave = false;
			} else {
				this.disableSave = true;
			}
			if (this.entity['_$changeStatus'] === true) {
				this.disabeChangeStatus = false;
			} else {
				this.disabeChangeStatus = true;
			}
		}

		this.sinisterDate = this.entity.sinisterDate ? this.userTime.utcToCalendarDate(this.entity.sinisterDate) : null;;
		this.expertDay = this.entity.expertDay ? this.userTime.utcToCalendarDate(this.entity.expertDay) : null;;
		this.workshopStartDate = this.entity.workshopStartDate ? this.userTime.utcToCalendarDate(this.entity.workshopStartDate) : null;;
		this.workshopEndDate = this.entity.workshopEndDate ? this.userTime.utcToCalendarDate(this.entity.workshopEndDate) : null;;
		this.vehiclePickupDate = this.entity.vehiclePickupDate ? this.userTime.utcToCalendarDate(this.entity.vehiclePickupDate) : null;;
		this.vehicleReturnDate = this.entity.vehicleReturnDate ? this.userTime.utcToCalendarDate(this.entity.vehicleReturnDate) : null;;
		this.endReparationDate = this.entity.endReparationDate ? this.userTime.utcToCalendarDate(this.entity.endReparationDate) : null;;

		
	    this.vehiclePlaceholder = this.translateService.instant('general.select');
		this.vehiclePlaceholder += ' ';
		this.vehiclePlaceholder += this.translateService.instant('tableManagement.cardLists.vehicle');

		if (this.entity.vehicle !== null && this.entity.vehicle !== undefined) {
			this.vehiclePlaceholder = this.entity.vehicle.name;
		}

		if (this.vehicle !== null && this.vehicle !== undefined) {
			this.editVehicle = false;
			this.entity.vehicle = this.vehicle;
		}

		this.vehicleRequestContext = {
			sortBy: 'name',
			sortAsc: true,
			pageSize: 10,
			filters: {},
			loadPermissions: false,
		} as Rest.ListPaginationRequest;



    this.leaderRequestContext = {
      sortBy: 'user.surname1',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
    } as Rest.ListPaginationRequest;
    this.leaderRequestContext.filters["fleetLeader"] = [true];
    
    this.sinisterTypeRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
    } as Rest.ListPaginationRequest;

	this.workshopRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
	} as Rest.ListPaginationRequest;

		    if(this.entity.driver){
      this.driverRequestContext.filters["user"] = [this.entity.driver.employee.code + " " + this.entity.driver.employee.user.surname1 + " " + this.entity.driver.employee.user.surname2 + ", " + this.entity.driver.employee.user.name ];
    }



		if(this.entity.vehicle){
			this.vehicleRequestContext.filters["name"] = [this.entity.vehicle.name];
		}



    if(this.entity.fleetManager){
      this.leaderRequestContext.filters["user"] = [this.entity.fleetManager.surname1 + " " + this.entity.fleetManager.surname2 + ", " + this.entity.fleetManager.name ];  
    }

    if(this.entity.sinisterType){
      this.sinisterTypeRequestContext.filters["name"] = [this.entity.sinisterType.name];
    }

	if(this.entity.workshop){
		this.workshopRequestContext.filters["name"] = [this.entity.workshop.name];
	}

			    this.driverService.getPage(this.driverRequestContext).then((p) => {
			this.driverList = p.entities.map((driver) => ({
				...driver,
				formatDriverLabel: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
			}));
		});

		this.invVehicleService.getPage(this.vehicleRequestContext).then((p) => {
			this.vehicleList = p.entities;
		});



    this.leaderService.getPage(this.leaderRequestContext).then((p) =>{
      this.fleetManagerList = p.entities.map((leader) => ({
			    ...leader.user,
				  formatResponsibleLabel: `${leader.user.surname1} ${leader.user.surname2}, ${leader.user.name}`,
			}));
    });

    this.sinisterTypeService.getPage(this.sinisterTypeRequestContext).then((p)=>{
      this.sinisterTypeList = p.entities;
    });

	this.workshopService.getPage(this.workshopRequestContext).then((p) => {
		this.workshopList = p.entities;
	})


	}

	afterShow() {
		//  console.log("[TAXES-FORM] afterShow ***");
		//  console.log(this.entity);
	}



	onChangeVehicle(event) {
		//  console.log('+++ onChangeVehicle', event);
		this.entity.vehicle = event.value;
		this.assignDriverFromVehicle();
	}

	onFilterVehicle(event) {
		this.vehicleRequestContext = {
			sortBy: 'name',
			sortAsc: true,
			pageSize: 10,
			filters: {
				name: [event.filter ?? ''],
			},
			loadPermissions: false,
		} as unknown as Rest.ListPaginationRequest;

		this.invVehicleService.getPage(this.vehicleRequestContext).then((p) => {
			this.vehicleList = p.entities;
		});
	}

	assignDriverFromVehicle() {
		// console.log('[FINE-FORM] assignDriverFromVehicle ***');
		if (this.entity.vehicle.driver != null) {
			this.entity.driver = {
					id: this.entity.vehicle.driver.id,
					employee: this.entity.vehicle.driver.employee,
				} as Rest.InvDriver;
			var driver = this.driverList.find((d) => d.id === this.entity.vehicle.driver.id);
			if (driver) {
				this.entity.driver = driver;
			} else {
				this.driverRequestContext.filters['user'] = [this.entity.vehicle.driver.employee.code + " " + this.entity.vehicle.driver.employee.user.surname1 + " " + this.entity.vehicle.driver.employee.user.surname2 + ", " + this.entity.vehicle.driver.employee.user.name];
				this.driverService.getPage(this.driverRequestContext).then((p) => {
					this.driverList = p.entities.map((driver) => ({
						...driver,
						formatDriverLabel: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
					}));
					this.entity.driver = this.driverList.find((d) => d.id === this.entity.vehicle.driver.id);
				});
			}

		}
	}

	//   onFileSelected(event) {
	//     this.file = event.target.files[0];

	//     console.log('+++ ', this.file);
	//     this.TaxService.createDocument(this.entity.id, this.vehicle, this.file);
	//   }

	onKeyDownDecimal(event: any) {
		var pressedKey = event.key;
		const keyMap = new Map<number, string>();
		keyMap.set(110, ',');
		keyMap.set(190, ",");
		const { keyCode } = event;
		if (!event.target.value.includes(',') && (keyMap.has(keyCode) || pressedKey === ',')) {
			event.preventDefault();
			event.target.value += ',';
		}
	}

	validateSinisterForm() {
		this.errorMessages = [];

		if (this.vehicle) {
			this.entity.vehicle = this.vehicle;
		}

		if (
			!this.entity.vehicle ||
			!this.entity.sinisterDate ||
			!this.entity.driver ||
			!this.entity.referenceNumber ||
			!this.entity.sinisterType
		) {
			this.errorMessages.push(this.translateService.instant('error.required-field.generic'));
			// this.notificationsService.add(
			// 	Severity.error,
			// 	this.translateService.instant(this.isNew ? 'general.createError' : 'updateError') + '!',
			// 	this.translateService.instant('error.required-field.generic')
			// );
			window.scroll({ top: 0, behavior: 'smooth' });
			this.saving = false;
		}
		return this.errorMessages.length === 0;
	}

	saveChanges() {
		// console.log("[TAXES-FORM] saveChanges ***");
		// console.log(this.entity);
		this.saving = true;

		this.beforeSave();

		if (this.validateSinisterForm()) {
			if (this.isNew) {
				// if (this.vehicle !== null) {
				// 	this.entity.vehicle = this.vehicle;
				// }


				this.SinisterService.create(this.entity).then((p) => {
					this.entity= p;
					//this.display = false;
					this.saving = false;
					this.isNew = false;
					this.SinisterService.refreshList.next({ vehicleId: this.entity.vehicle.id});
					this.return.emit(p);
				});
			} else {

				this.SinisterService.update(this.entity).then((p) => {
					this.display = false;
					this.saving = false;
					this.return.emit(p);
					this.SinisterService.refreshList.next({ vehicleId: this.entity.vehicle.id});
				});
			}
		}
	}

	protected beforeSave(): void {
		this.entity.sinisterDate = this.sinisterDate != null ? new Date(this.userTime.toUTCISOString(this.sinisterDate)): null;
		this.entity.expertDay = this.expertDay != null ? new Date(this.userTime.toUTCISOString(this.expertDay)): null;
		this.entity.workshopStartDate = this.workshopStartDate != null ? new Date(this.userTime.toUTCISOString(this.workshopStartDate)): null;
		this.entity.workshopEndDate = this.workshopEndDate != null ? new Date(this.userTime.toUTCISOString(this.workshopEndDate)): null;
		this.entity.vehiclePickupDate = this.vehiclePickupDate != null ? new Date(this.userTime.toUTCISOString(this.vehiclePickupDate)): null;
		this.entity.vehicleReturnDate = this.vehicleReturnDate != null ? new Date(this.userTime.toUTCISOString(this.vehicleReturnDate)): null;
		this.entity.endReparationDate = this.endReparationDate != null ? new Date(this.userTime.toUTCISOString(this.endReparationDate)): null;
	}

	refresh() {
		// console.log("[TAX-FORM] refresh");
		this.return.emit();
		//this.saveChanges();
	}

  onChangeDriver(event) {
		this.entity.driver = event.value;
	}

	onFilterDriver(event) {
		console.log(event.filter);
		this.driverRequestContext.filters['user'] = [event.filter ?? ''];
		this.driverService.getPage(this.driverRequestContext).then((p) => {
			this.driverList = p.entities.map((driver) => ({
				...driver,
				formatDriverLabel: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
			}));
		});
	}

  onChangeFleetManager(event){
    this.entity.fleetManager = event.value;
  }

  onFilterFleetManager(event){
    this.leaderRequestContext.filters['user'] = [event.filter ?? ''];
		this.leaderService.getPage(this.leaderRequestContext).then((p) => {
			this.fleetManagerList = p.entities.map((leader) => ({
				...leader.user,
				formatDriverLabel: `(${leader.user.surname1} ${leader.user.surname2}, ${leader.user.name}`,
			}));
		});
  }

  onChangeSinisterType(event){
    this.entity.sinisterType = event.value;
  }

  onFilterSinisterType(event){
    this.sinisterTypeRequestContext.filters['name'] = [event.filter ?? ''];
    this.sinisterTypeService.getPage(this.sinisterTypeRequestContext).then((p) =>{
      this.sinisterTypeList = p.entities;
    })
  }

  onChangeWorkshop(event){
	this.entity.workshop = event.value;
  }

  onFilterWorkshop(event){
	this.workshopRequestContext.filters['name'] = [event.filter ?? ''];
	this.workshopService.getPage(this.workshopRequestContext).then((p) =>{
		this.workshopList = p.entities;
	});
  }

  addWorkshop() {
		this.workshopForm.create();
		this.workshopForm.return.subscribe((value) => {
			
			this.workshopService.getPage(this.workshopRequestContext).then((p) => {
				this.workshopList = p.entities;
			})
		});
	}

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_SINISTER_CREATE', 'INV_SINISTER_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
  }


}

